import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "credits", "costDisplay"]
  static values = { centsPerThousand: Number, minCredits: Number }

  toggle() {
    this.formTarget.classList.toggle("hidden")
    this.updateEstimatedCost()
  }

  updateEstimatedCost() {
    if (!this.hasCreditsTarget || !this.hasCostDisplayTarget) return

    const credits = parseInt(this.creditsTarget.value || 0, 10)
    if (credits >= this.minCreditsValue) {
      const amountCents = Math.round(credits / 1000 * this.centsPerThousandValue)
      this.costDisplayTarget.value = "$" + (amountCents / 100).toFixed(2)
    } else {
      this.costDisplayTarget.value = ""
    }
  }
}
